<template>
	<div>
    <h1>This is a webWidgetTest </h1>

	</div>
</template>

<script>

export default {
  name: 'program-guide-test',
  props: [],
  data: () => {
    return {
    }
  },
  mounted () {

  },

  methods: {

  },
  computed: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideTest.vue